export const APPLICATION_DOCUMENT_MAX_SIZE_BYTES = 500 * 1000;
export const APPLICATION_DOCUMENT_SIZE_ERROR = "File size must not exceed 500 KB";

export const isApplicationDocumentSizeAllowed = file =>
  !file || file.size <= APPLICATION_DOCUMENT_MAX_SIZE_BYTES;

export const applicationDocumentSizeRule = file =>
  isApplicationDocumentSizeAllowed(file) || APPLICATION_DOCUMENT_SIZE_ERROR;
